import { Component } from 'react';
import { Contribution } from '../../../../../../../common/model/input/contributions/types';
import { ModalOptions } from '../../../../../../untidy/redux/modules/modal';
import { aiName } from '../../../../../../untidy/texts';
import { TextField } from '../../../../../generic/components/inputs/text-field';
import { themeDEPRECATED } from '../../../../../generic/global/styles';
import {
  ContributionModalParagraph,
  ContributionModalTitle,
  FormRow,
  FullRow,
  Label,
  ProductCodeWithLabel,
  ProductRow,
} from './common';
import { FormButton } from './form-button';

interface State {
  comment?: string;
  products?: ProductCodeWithLabel[];
}

interface Props {
  isSubmitting: boolean;
  submitContribution: (options: { target?: string; data: Contribution }) => void;
  options: ModalOptions;
}

export class InvalidCompanyProductsForm extends Component<Props, State> {
  public state: State = {};

  public render() {
    const { isSubmitting, options } = this.props;
    const { products, comment } = this.state;

    if (!options.existingData || !options.existingData.products) {
      console.error('Missing required metadata for company');
      return null;
    }

    const {
      target,
      targetName,
      existingData: { products: companyProducts },
    } = options;

    const canSubmit = !!products && products.length > 0;

    return (
      <>
        <ContributionModalTitle>Which products shouldn't be associated with {targetName}?</ContributionModalTitle>
        <ContributionModalParagraph>
          A company's profile should only include the products and services the company produces and sells.
        </ContributionModalParagraph>
        <form
          onSubmit={e => {
            e.preventDefault();
          }}
        >
          <FormRow>
            <FullRow>
              <Label>Which products should be removed from this company?</Label>
              {companyProducts
                .sort((a, b) => a.label.localeCompare(b.label))
                .map(productDatum => (
                  <ProductRow key={productDatum.productCode}>
                    <label>
                      <input
                        name="isGoing"
                        type="checkbox"
                        checked={
                          !!this.state.products &&
                          !!this.state.products.find(p => p.productCode === productDatum.productCode)
                        }
                        onChange={e =>
                          e.target.checked
                            ? this.setState(state => ({
                                products: (state.products || []).concat(productDatum),
                              }))
                            : this.setState(state => ({
                                products:
                                  state.products &&
                                  state.products.filter(p => p.productCode !== productDatum.productCode),
                              }))
                        }
                      />{' '}
                      {productDatum.label}
                    </label>
                  </ProductRow>
                ))}
            </FullRow>
          </FormRow>
          <FormRow>
            <TextField
              label="Anything else you want to share?"
              id="comment"
              type="textarea"
              value={comment}
              disabled={isSubmitting}
              metaLabel="Optional"
              onChange={value => {
                this.setState({ comment: value });
              }}
            />
          </FormRow>
          <ContributionModalParagraph style={{ marginTop: themeDEPRECATED.rhythm(5) }}>
            Please note that contributions will not automatically affect the data in the model, but will be processed
            and evaluated either by {aiName} or the Upright team.
          </ContributionModalParagraph>
          <FormRow>
            <FormButton
              type="submit"
              disabled={isSubmitting || !canSubmit}
              onClick={() => {
                if (this.state.products && this.state.products.length > 0) {
                  this.props.submitContribution({
                    data: {
                      type: 'COMPANY_INVALID_PRODUCTS',
                      comment: this.state.comment,
                      products: this.state.products.map(p => p.productCode),
                    },
                    target,
                  });
                }
              }}
              style={{ width: '100%' }}
            >
              Submit
            </FormButton>
          </FormRow>
        </form>
      </>
    );
  }
}
